module.exports = __webpack_public_path__ + "static/media/Group 1.b29a541d.svg";